import PaceAccordion from "./PaceAccordion";

export default PaceAccordion;
